import api from '@src/apis/api';
import { ASR_URL, VBEE_CONSOLE_URL } from '@src/configs';

export const recognizeSpeechToText = async (payload) => {
  try {
    const response = await api({
      method: 'POST',
      url: `${ASR_URL}/api/v1/stt`,
      data: payload,
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

export const getSTTStats = async ({ appId, startDate, endDate, signal }) => {
  const response = await api({
    method: 'GET',
    url: `${VBEE_CONSOLE_URL}/app/v1/stt/transcripts/stats`,
    params: { appId, startDate, endDate },
    signal,
  });
  return response;
};

export const redeliverSTTCallback = async ({ transcriptId }) => {
  try {
    const response = await api({
      method: 'POST',
      url: `${VBEE_CONSOLE_URL}/app/v1/stt/transcripts/${transcriptId}/webhook/redeliver`,
    });
    return response;
  } catch (error) {
    return error.response?.data || null;
  }
};

export const getSTTTranscriptDetail = async ({ transcriptId, signal }) => {
  const response = await api({
    method: 'GET',
    url: `${VBEE_CONSOLE_URL}/app/v1/stt/transcripts/${transcriptId}`,
    signal,
  });
  return response;
};

export const getSTTTranscripts = async ({
  appId,
  limit,
  offset,
  startDate,
  endDate,
  status,
  signal,
}) => {
  const response = await api({
    method: 'GET',
    url: `${VBEE_CONSOLE_URL}/app/v1/stt/transcripts`,
    params: { appId, limit, offset, startDate, endDate, status },
    signal,
  });
  return response;
};
